import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { EventBusService } from '../../app/fsl/services/shared/event-bus.service';

@Component({
  selector: 'adminapp-publish-history-modal',
  templateUrl: './publish-history-modal.component.html',
  styleUrls: ['./publish-history-modal.component.scss']
})
export class PublishHistoryModalComponent implements OnInit {

  @ViewChild('publishHistoryModal') publishHistoryModal;
  @ViewChild('publishButton') publishButton;

  buttonText = '';
  modalTitleText = '';
  _isSetupAnalyticsComplete: boolean;
  _isUnifiedFlowEnabled: boolean;
  displayAnalyticsNotCompletedText: boolean = false;
  @Output()
  startPublishEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  set isUnifiedFlowEnabled(unifiedFlowEnabled: boolean) {
    if (this._isUnifiedFlowEnabled !== unifiedFlowEnabled) {
    this._isUnifiedFlowEnabled = unifiedFlowEnabled;
    this.setUpModal();
    }
  }

  @Input()
  set isSetupAnalyticsComplete(isSetupAnalyticsComplete: boolean) {
    if (this._isSetupAnalyticsComplete === isSetupAnalyticsComplete) {
      return;
    }
    this._isSetupAnalyticsComplete = isSetupAnalyticsComplete;
    this.setUpModal();
  }

  constructor(
    private eventBus: EventBusService
    ) { }

  ngOnInit() {
    this.publishButton.nativeElement.addEventListener('click', this.onButtonClicked.bind(this));
  }

  setUpModal() {
    if (this._isSetupAnalyticsComplete === true) {
      this.modalTitleText = 'Do you want to Publish Point History?';
      this.buttonText = 'YES';
    }  else if (this._isSetupAnalyticsComplete === false) {
      this.modalTitleText = 'Setup Analytics not completed';
      this.displayAnalyticsNotCompletedText = true;
      this.buttonText = 'MANAGE ASSETS';
    }
    this.setModalTitleText();
  }

  setModalTitleText() {
    this.publishHistoryModal.nativeElement.titleText = this.modalTitleText;
  }

  open() {
    this.publishHistoryModal.nativeElement.open();
  }

  close() {
    this.publishHistoryModal.nativeElement.close();
  }

  onButtonClicked() {
    if (this._isSetupAnalyticsComplete === true) {
      this.startPublishEventEmitter.emit({});
    }  else if (this._isSetupAnalyticsComplete === false) {
      this.eventBus.conveyToNavigate('/identify-assets');
    }
  }

}
